import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';

import { AsyncJobType } from '@recruitee/account/data';
import { bulkActionEffectFactory } from '@recruitee/async-job/data';

import { BulkActionsHttpClient } from './bulk-actions-http-client';
import { OfferBulkActions } from './bulk-actions.store';

@Injectable({ providedIn: 'root' })
export class OfferBulkActionsEffects {
  public follow$ = bulkActionEffectFactory(
    this.actions$,
    OfferBulkActions,
    'follow',
    AsyncJobType.BulkOffersFollow,
    params => this.bulkActionsHttpClient.follow(params),
  );

  public unfollow$ = bulkActionEffectFactory(
    this.actions$,
    OfferBulkActions,
    'unfollow',
    AsyncJobType.BulkOffersUnfollow,
    params => this.bulkActionsHttpClient.unfollow(params),
  );

  public deleteArchived$ = bulkActionEffectFactory(
    this.actions$,
    OfferBulkActions,
    'deleteArchived',
    AsyncJobType.BulkOffersDeleteArchived,
    params => this.bulkActionsHttpClient.deleteArchived(params),
  );

  public retrieveArchived$ = bulkActionEffectFactory(
    this.actions$,
    OfferBulkActions,
    'retrieveArchived',
    AsyncJobType.BulkOffersRetrieveArchived,
    params => this.bulkActionsHttpClient.retrieveArchived(params),
  );

  public enableReferrals$ = bulkActionEffectFactory(
    this.actions$,
    OfferBulkActions,
    'enableReferrals',
    AsyncJobType.BulkOffersEnableReferralProgram,
    params => this.bulkActionsHttpClient.enableReferrals(params),
  );

  public disableReferrals$ = bulkActionEffectFactory(
    this.actions$,
    OfferBulkActions,
    'disableReferrals',
    AsyncJobType.BulkOffersDisableReferralProgram,
    params => this.bulkActionsHttpClient.disableReferrals(params),
  );

  constructor(public bulkActionsHttpClient: BulkActionsHttpClient, private actions$: Actions) {}
}
